import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { DOCUMENTS } from 'content';
import { mdToHtml } from 'utils/markdown';

async function fetchJson(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error('Failed to load ' + url);
  return res.json();
}

async function fetchText(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error('Failed to load ' + url);
  return res.text();
}

function Documents() {
  const [docs, setDocs] = useState(DOCUMENTS);
  const [activeId, setActiveId] = useState(DOCUMENTS[0]?.id);
  const active = docs.find(d => d.id === activeId) || docs[0];

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const manifest = await fetchJson('/docs/manifest.json');
        const loaded = [];
        for (const d of manifest.docs || []) {
          const bodyMd = await fetchText(`/docs/${d.file}`);
          loaded.push({ ...d, body: bodyMd, markdown: true });
        }
        if (loaded.length && mounted) {
          setDocs(loaded);
          setActiveId(loaded[0].id);
        }
      } catch (e) {
        // Fallback to inline docs
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);
  return (
    <Div>
      <aside className="sidebar">
        <ul>
          {docs.map(doc => (
            <li key={doc.id}>
              <button
                onClick={() => setActiveId(doc.id)}
                className={activeId === doc.id ? 'active' : ''}
                title={doc.title}
              >
                {doc.title}
              </button>
            </li>
          ))}
        </ul>
      </aside>
      <main className="content">
        <h1>{active.title}</h1>
        {active.date && <div className="meta">{active.date}</div>}
        {active.tags?.length ? (
          <div className="tags">{active.tags.map(t => `#${t}`).join(' ')}</div>
        ) : null}
        {active.markdown ? (
          <div
            className="body md"
            dangerouslySetInnerHTML={{ __html: mdToHtml(active.body) }}
          />
        ) : (
          <pre className="body">{active.body}</pre>
        )}
      </main>
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: grid;
  grid-template-columns: 220px 1fr;
  overflow: hidden;
  background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);

  .sidebar {
    border-right: 1px solid rgba(0, 0, 0, 0.15);
    background: #f8f8f8;
    overflow: auto;
  }
  .sidebar ul {
    list-style: none;
    margin: 0;
    padding: 6px;
  }
  .sidebar li {
    margin: 0 0 6px;
  }
  .sidebar button {
    width: 100%;
    text-align: left;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 6px 8px;
    font-size: 12px;
  }
  .sidebar button.active {
    background: #dbe8ff;
  }

  .content {
    overflow: auto;
    padding: 12px;
  }
  h1 {
    font-size: 16px;
    margin: 0 0 4px;
  }
  .meta {
    font-size: 11px;
    color: #666;
    margin-bottom: 6px;
  }
  .tags {
    font-size: 11px;
    color: #2f71cd;
    margin-bottom: 8px;
  }
  .body {
    white-space: pre-wrap;
    font-family: Consolas, 'Courier New', monospace;
    font-size: 12px;
    line-height: 1.4;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 10px;
  }
`;

export default Documents;
